import { Component } from '@angular/core';

@Component({
  selector: 'lib-call-to-action',
  templateUrl: './call-to-action.component.html',
  styleUrls: ['./call-to-action.component.scss'],
})
export class CallToActionComponent {}
